import { ReactElement, useState } from 'react'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'

import Heading from 'components/v2/Heading'
import { ArrowCircleRightIcon } from '@10xLabs/react-web/components/Icons/ArrowCircleRight'
import { StyledLink } from 'components/v2/Link'
import Modal from 'components/v2/Modal'
import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from '@10xLabs/react-web/components/Table'
import { LabelWrapper, Label, ReturnIcon } from 'features/Bookings/components/Service'
import { isEmpty } from 'lodash'

const Wrapper = styled.div`
  margin: -10px 0;
`

const Item = styled.div`
  margin: 10px 0;
`

export const SegmentsByRoute = ({ segments }: TSFixMe): ReactElement => {
  const [isModalOpen, setModalOpen] = useState(false)

  return (
    <div>
      {segments.length > 0 ? (
        <div>
          <StyledLink onClick={(): void => setModalOpen(true)}>{segments.length}</StyledLink>
        </div>
      ) : (
        0
      )}
      {isModalOpen && (
        <Modal.Container large>
          <Modal.Header onClose={(): void => setModalOpen(false)}>
            <Heading.H5>
              <FormattedMessage id="fareRules.list.segments.title" defaultMessage="Segments" />
            </Heading.H5>
          </Modal.Header>
          <Modal.Content>
            <TableContainer overflow>
              <Table>
                <Thead>
                  <Tr>
                    <Th>
                      <FormattedMessage id="dictionary.code" defaultMessage="Code" />
                    </Th>

                    <Th>
                      <FormattedMessage id="dictionary.origin" defaultMessage="Origin" />
                    </Th>

                    <Th>
                      <FormattedMessage id="dictionary.destination" defaultMessage="Destination" />
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {segments.map((segment: TSFixMe, index: number) => {
                    return (
                      <Tr key={index}>
                        <Td>
                          {segment.origin.code} - {segment.destination.code}
                        </Td>
                        <Td>{segment.origin.name}</Td>
                        <Td>{segment.destination.name}</Td>
                      </Tr>
                    )
                  })}
                </Tbody>
              </Table>
            </TableContainer>
          </Modal.Content>
        </Modal.Container>
      )}
    </div>
  )
}

export const BaseRuleSegments = ({ baseRule }: TSFixMe): ReactElement => {
  const isAllSegments = baseRule.citySegments.every((citySegment: TSFixMe) => isEmpty(citySegment.segments))
  if (isAllSegments) {
    return (
      <div>
        <FormattedMessage id="baseRuleSegments.list.segments.all" defaultMessage="All Segments" />
      </div>
    )
  }
  return (
    <Wrapper>
      {baseRule.citySegments.map((citySegment: TSFixMe, index: number) => {
        return (
          <Item key={index}>
            {baseRule.citySegments.length > 1 && (
              <LabelWrapper>
                {index === 0 ? <ArrowCircleRightIcon /> : <ReturnIcon />}
                <Label>
                  <FormattedMessage
                    id="fareRules.list.routes.count"
                    defaultMessage="Route #{routeNumber}"
                    values={{
                      routeNumber: index + 1
                    }}
                  />
                </Label>
              </LabelWrapper>
            )}
            <SegmentsByRoute segments={citySegment.segments} />
          </Item>
        )
      })}
    </Wrapper>
  )
}
